import { useCallback } from "react";

import { apiClient } from "../../lib/api";

import type { ApiPayload } from "common/classes/api-payload";

export function useResendConfirmation(): (email: string) => Promise<ApiPayload> {
  const resendConfirmation = useCallback(async (email: string): Promise<ApiPayload> => {
    const response = await apiClient.resendConfirmationEmail(email);

    return response;
  }, []);

  return resendConfirmation;
}
